export { MySiteFeaturedProducts, MySiteProductBundles, MySiteWelcome } from '@nuskin/my-site-home';

import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import template from './my-site-preview.html';

import { RunConfigService } from '@nuskin/ns-util';
import { PriceType } from '@nuskin/ns-shop'

import { SidebarMenu } from '@nuskin/my-site/src/my-site-app/sidebar-menu/sidebar-menu';
import { ContactInformation } from '../forms/contact-information/contact-information';
import { SocialNetworks } from '../forms/social-networks/social-networks';
import { FullProductCatalog } from '../forms/full-product-catalog/full-product-catalog';
import { LogoAndProfilePhoto } from '../forms/logo-and-profile-photo/logo-and-profile-photo';
import { AboutYourStore } from '../forms/about-your-store/about-your-store';
// import { FeaturedProducts } from '../forms/featured-products/featured-products';
import { ProductBundles } from '../forms/product-bundles/product-bundles';
import { BundleUpdateCreate } from '../forms/bundle-update-create/bundle-update-create';
// import { BannerContent } from '../forms/banner-content/banner-content';
import { MySiteRestService } from '@nuskin/my-site-api';

export class MySitePreview extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.mySiteHomeTranslations = translationService.getTranslations(context) || {};
        this.searchTranslation = this.mySiteHomeTranslations.headerConfig.tdc_searchButton || 'Search'
        if(this.mySiteHomeTranslations.headerConfig 
      && this.mySiteHomeTranslations.headerConfig.headerNavigation) {
            this.set('mySiteHeaderNavigation', this.mySiteHomeTranslations.headerConfig.headerNavigation);
        }

        this.set('mySiteHeaderRegions', this.mySiteHomeTranslations.headerConfig.regions);

        let hideMyAccount = !!this.mySiteHomeTranslations.headerConfig.hideMyAccount;
        this.set('showProfile', !hideMyAccount);
    
        this.forms = {
            // bannerContent: BannerContent.is,
            contactInformation: ContactInformation.is,
            socialNetworks: SocialNetworks.is,
            fullProductCatalog: FullProductCatalog.is,
            logoAndProfilePhoto: LogoAndProfilePhoto.is,
            aboutYourStore: AboutYourStore.is,
            // featuredProducts: FeaturedProducts.is,
            productBundles: ProductBundles.is
        }
        this.mySite = window.parent.document.querySelector('my-site-app') || {};
        this.set('content', this.mySite.content);
        // eslint-disable-next-line no-undef
        this.mySite.mySiteHomeTranslations = translationService.getTranslations(context) || {};
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get properties() {
        return {
            fullProductCatalog: {
                type: Boolean,
                observer: '_handleFullProductCatalog'
            }
        }
    }

    static get is() {
        return 'my-site-preview';
    }

    async ready() {
        super.ready();
        this.runConfig = RunConfigService.getRunConfig();
        this.mySite.addEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
        this.mySite.$.screenType.addEventListener('selected-changed', this._handleScreenTypeChange.bind(this));
        this.mySite.addEventListener('savingForm', this._handleLoading.bind(this));
        this.mySite.addEventListener('current-zoom-changed', this._handleAutoScroll.bind(this));
        this.mySite.addEventListener('on-menu-item-click', this._handleMenuItemClick.bind(this));
        this.mySite.addEventListener('screen-type-changed', this._handleMenuItemClick.bind(this));
        this.mySite.addEventListener('full-product-catalog-form-visibility-changed', this._handleFullProductCatalogFormVisibilityChange.bind(this));
        this.$.headerOverlay.addEventListener('click', this.goBack.bind(this));

        this.isMobile = window.parent.window.innerWidth < this.mySite.desktopWidth;
        if(!this.isMobile) {
            this.set('spinnerCaption', this.mySite.content.mySiteUpdatingSpinner || 'Updating...');
            this.set('loading', true);
        }

        // set translation for header's ns-searchabr
        // TODO: do we need this ?
        // try {
        //   this.$.nsHeader.shadowRoot.querySelector('ns-searchbar').translations = {
        //     desktopPlaceholder: this.mySiteHomeTranslations.headerConfig.tdc_desktopPlaceholder,
        //     mobilePlaceholder: this.mySiteHomeTranslations.headerConfig.tdc_mobilePlaceholder,
        //     search: this.mySiteHomeTranslations.headerConfig.tdc_searchButton
        //   }
        // } catch (err){}

        document.body.style.overflow = 'unset'
        this.navItems = await MySiteRestService.getMySiteNav(this.mySite.currentMarket, this.mySite.currentLanguage)

    }

    disconnectedCallback() {
        super.disconnectedCallback();

        this.mySite.removeEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
        this.mySite.$.screenType.removeEventListener('selected-changed', this._handleScreenTypeChange.bind(this));
        this.mySite.removeEventListener('savingForm', this._handleLoading.bind(this));
        this.mySite.removeEventListener('current-zoom-changed', this._handleAutoScroll.bind(this));
        this.mySite.removeEventListener('on-menu-item-click', this._handleMenuItemClick.bind(this));
        this.mySite.removeEventListener('screen-type-changed', this._handleMenuItemClick.bind(this));
        this.mySite.removeEventListener('full-product-catalog-form-visibility-changed', this._handleFullProductCatalogFormVisibilityChange.bind(this));
        this.$.headerOverlay.removeEventListener('click', this.goBack.bind(this));

    }

    goBack() {
        this.mySite.overlayClick();
    }

    _handleFullProductCatalog(newVal) {
        if(newVal) {
            this.showSearchBar = !this.mySiteHomeTranslations.headerConfig.hideSearchBar
            this.showNav = !this.mySiteHomeTranslations.headerConfig.hideTopNav 
        } else {
            this.showSearchBar = false
            this.showNav = false
        }
    }

    getCurrentLanguageTitle(){
        let languageTitle = ''
        if(this.mySite && this.mySite.marketsAndLanguages) {
            Object.keys(this.mySite.marketsAndLanguages).forEach(market => {
                if(market === this.mySite.currentMarket) {
                    let m = this.mySite.marketsAndLanguages[market]
                    m.languages.forEach(lang => {
                        if (lang.code === this.mySite.currentLanguage) {
                            languageTitle = lang.displayName;
                        }
                    })
                }
            })
        }
        return languageTitle;
    }

    getCurrentMarketTitle(){
        let marketTitle = '';
        if(this.mySite && this.mySite.marketsAndLanguages) {
            Object.keys(this.mySite.marketsAndLanguages).forEach(market => {
                if(market === this.mySite.currentMarket) {
                    let m = this.mySite.marketsAndLanguages[market];
                    marketTitle = m.defaultLocale ? m.defaultLocale.defaultDisplayCountry : ''
                }
            });
        }
        return marketTitle;
    }

    _handleMenuItemClick(e) {

        let isMobile = e.detail && e.detail.mobile ;

        if(isMobile) return;

        let overlay = this.$.mySiteHeaderOverlay;
        // handle overlay for site and profile pictures
        if(e.detail.item === this.forms.logoAndProfilePhoto) {
            //site logo
            this.$.mySiteHeader.className += ' custom-overlay-for-logo';
            try {
                this.$.nsHeader.querySelector('#headerOverlay').show();
            } catch (error) {
                throw new Error('header overlay error')
            }
            overlay.className += ' hide';

            // profile photo
            let elem = this.root.getElementById(this.forms.aboutYourStore);
            elem.className += ' custom-overlay-for-logo';
            this.$.mySiteWelcome.querySelector('#profileOverlay').show();
            this.$.mySiteWelcomeOverlay.className += ' hide';
        } else {
            // site logo
            setTimeout(() => {
                this.$.mySiteHeader.className = this.$.mySiteHeader.className.split(' custom-overlay-for-logo').join('');
            }, 300); // 300 - matches animation delay
            try {
                this.$.nsHeader.querySelector('#headerOverlay').hide();
            } catch (error) {
                throw new Error('header overlay error')
            }
            overlay.className = overlay.className.split(' hide').join('');

            // profile photo
            let elem = this.root.getElementById(this.forms.aboutYourStore);
            setTimeout(() => {
                elem.className = elem.className.split(' custom-overlay-for-logo').join('');
            }, 300); // 300 - matches animation delay
            this.$.mySiteWelcome.querySelector('#profileOverlay').hide();
            this.$.mySiteWelcomeOverlay.className = this.$.mySiteWelcomeOverlay.className.split(' hide').join('');
        }

        this._handleAutoScroll();
    }

    // TODO: actual safari on ios has broken app
    // TODO: sortable is still funky

    _handleAutoScroll() {
    // handle autoscroll
        setTimeout(() => {
            let form = this.mySite.currentForm;
            if(form === SidebarMenu.is) return;
            // exceptions:
            form = form === BundleUpdateCreate.is ? ProductBundles.is : form;
            form = [ContactInformation.is, SocialNetworks.is].indexOf(form) !== -1 ? 'mySiteFooter' : form ;
            form = form === FullProductCatalog.is ? 'mySiteHeader' : form;

            let highlightedElem = this.shadowRoot.querySelector(`#${form}`);
            let elemOffsetTop = highlightedElem ? highlightedElem.offsetTop : 0;
      
            window.scroll({
                top: elemOffsetTop * this.mySite.currentZoom,
                behavior: 'smooth'
            });
        }, 300);
    }

    _handleFullProductCatalogFormVisibilityChange() {
        this.set('headerAction', this.mySite.fullProductCatalogFormVisibility ? this.forms.fullProductCatalog : this.forms.logoAndProfilePhoto);
    }

    _handleLoading() {
    // handle mobile and desktop loading spinners
        if(!this.isMobile)
            this.set('loading', true);
        else {
            this.mySite.set('iframeLoading', true);
            this.mySite.set('spinnerCaption', this.mySite.content.mySiteUpdatingSpinner);
        }
    }

    _handleScreenTypeChange(e) {
        let desktop = e.detail.value*1 === 0;
        this.ignoreResponsive = !desktop;
    }

    chooseBanner() {
        this.mySite.currentForm = this.forms.bannerContent;
        this.mySite.dispatchEvent(new CustomEvent('on-menu-item-click', {
            composed: true, 
            detail: {
                item: this.forms.bannerContent,
                mobile: this.isMobile
            }
        }));
    }

    addBundle() {
        let bundlesForm = this.mySite.$.mySiteSidebarWrapper.querySelector(ProductBundles.is);
        this.mySite.currentForm = this.forms.productBundles;
        this.mySite.dispatchEvent(new CustomEvent('on-menu-item-click', {
            composed: true, 
            detail: {
                item: this.forms.productBundles,
                mobile: this.isMobile
            }
        }));
        bundlesForm._onCreateBundleClick();
    }

    async _subscribeToMySiteDataChanges(e) {
        let mySiteData = e.detail.value;
        this.set('sponsor', mySiteData);

        if(!this.mySite.subdomain) return;

        let country = mySiteData.storefront[this.mySite.subdomain][this.mySite.currentMarket];
        let language = country.lang[this.mySite.currentLanguage];

        this.set('displayName', this.sponsor.displayName);
        this.set('useDefaultLogos', this.sponsor.useDefaultLogos);
        this.set('email', this.sponsor.email);
        this.set('phone', this.sponsor.phone.replace(/x/g, ''));
        this.set('socialAccounts', this.sponsor.socialAccounts);
        this.set('storeName', language.storeName || this.mySiteHomeTranslations.tdc_welcomeSectionSiteName);
        this.set('aboutYourStore', language.aboutYourStore || this.mySiteHomeTranslations.tdc_welcomeSectionAboutYourSite);
        this.set('selectedBanner', language.banner);
        this.set('priceType', language.wholesale ? PriceType.WWHL : null);
        this.set('selectedBannerTranslations', {
            ctaCopy: this.selectedBanner ? this.selectedBanner.ctaText : ''
        });
        this.set('aboutProducts', language.aboutProducts || this.mySiteHomeTranslations.tdc_featuredProductsDescription);
        this.set('profilePhoto', mySiteData.profilePhoto || (this.sponsor.useDefaultLogos ? this.mySiteHomeTranslations.welcomeSectionProfileImageReference : ''));
        this.set('siteLogo', mySiteData.siteLogo || (this.sponsor.useDefaultLogos ? this.mySiteHomeTranslations.welcomeSectionLogoImageReference : ''));
        // since default picture is a square picture of ns-logo
        this.set('isSquare', this.siteLogo === this.mySiteHomeTranslations.welcomeSectionLogoImageReference);
    
        this.set('fullProductCatalog', !!language.fullProductCatalog || !this.content.fullProductCatalogFormVisibility);
        this.set('noBanner', !this.selectedBanner);
        this.set('showNsLogo', !this.sponsor.useProfilePhotoAsLogo && !this.sponsor.siteLogo)
  
        this.set('products', country.products ? country.products.slice(0, 3) : []);
        this.set('bundles', country.bundles ? country.bundles.slice() : []); 
        this.set('bundlesInfo', language.bundlesInfo || []);

        // TODO: When V2 kicks in refactor this. 
        this.set('bundleTranslations', {
            'title': this.mySiteHomeTranslations['tdc_featuredBundleTitle'],
            'defaultBundleMessage': this.mySiteHomeTranslations['tdc_defaultBundlesMessage'],
            'items': this.mySiteHomeTranslations['tdc_featuredBundleItemsLabel'],
            'addItemsToCart': this.mySiteHomeTranslations['tdc_featuredBundleAddItemsLabel']
        });

        // handle mobile and desktop loading spinners
        if(!this.isMobile)
            this.set('loading', false);
        else {
            this.mySite.set('iframeLoading', false);
            this.mySite.set('spinnerCaption', this.content.mySiteLoadingSpinner || 'Loading...');
        }

        this.mySite.$.iframe.className = this.mySite.$.iframe.className.split(/\s?hidden/).join('');

        this.set('showSquare', this.useDefaultLogos || (!this.useDefaultLogos && this.isSquare));
        this.set('showCircle', !this.useDefaultLogos && !this.isSquare);

        if(this.showSquare)
            this.$.siteLogoOverlay.setAttribute('square', '');
        else
            this.$.siteLogoOverlay.removeAttribute('square');
    
        this.set('headerAction', this.mySite.fullProductCatalogFormVisibility ? this.forms.fullProductCatalog : this.forms.logoAndProfilePhoto);
    }

}

window.customElements.define(MySitePreview.is, MySitePreview);